<template>
  <div class="order-list">
    <template v-if="!isEmpty">
      <div v-if="title" class="order-list-title">{{ title }}</div>
      <div class="order-list__content">
        <div class="order-list_body">
          <slot />
        </div>
      </div>
    </template>

    <template v-else>
      <Result
        :src="require('@/assets/no-order.png')"
        :text="$t('noTransationRecords')"
      />
    </template>
  </div>
</template>

<script>
import Result from '@/components/Result'
export default {
  name: 'OrderList',

  components: {
    Result
  },

  props: {
    title: {
      type: String,
      default: ''
    },

    isEmpty: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.order-list__content {
  background-color: #fff;
  border-radius: 16px;
  padding-right: 37px;
  box-shadow: 0 8px 32px 0 rgba(138, 149, 158, 0.2);
}

.order-list-title {
  margin-bottom: 32px;
  font-size: 24px;
  color: #7f7f7f;
}
</style>
